import { render } from "./Pay2mFormDialog.vue?vue&type=template&id=62d354d4&scoped=true"
import script from "./Pay2mFormDialog.vue?vue&type=script&lang=js"
export * from "./Pay2mFormDialog.vue?vue&type=script&lang=js"

import "./Pay2mFormDialog.vue?vue&type=style&index=0&id=62d354d4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62d354d4"]])

export default __exports__